<style lang="less">
@import "./dataBrain.less";
</style>
<template>
  <div class="dataBrain">
    <el-row>
      <el-col :span="24" class="header">
        <el-row>
          <el-col :span="8" class="area">
            <div class="backArea">
              <img src="@/assets/dataBrain/back.png" @click="goBack" />
            </div>
            <div class="weaArea">
              <div>
                <span>{{city}}</span>
                <img :src="wea_img" />
              </div>
              <div>{{tem2}}℃ ~ {{tem1}}℃</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="titleArea">
              <span class="title">{{companyName}} · 数据大脑</span>
              <p>
                <img src="@/assets/dataBrain/line.png" />
              </p>
            </div>
          </el-col>
          <el-col :span="8" class="timeArea">
            <p>{{time}}</p>
            <p>技术支持：阿中软件</p>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="9" style="width: 30%!important; padding-right: 5px; padding-left: 5px;">
        <!-- <el-row >
          <el-col :span="3">
            <div class="backArea">
              <img src="@/assets/dataBrain/back.png" @click="goBack" />
            </div>
          </el-col>
          <el-col :span="21">
            <div class="weaArea">
              <div>
                <span>{{city}}</span>
                <img :src="wea_img" />
              </div>
              <div>{{tem2}}℃ ~ {{tem1}}℃</div>
            </div>
          </el-col>
        </el-row>-->
        <div class="chart1 borderOut">
          <div class="topL"></div>
          <div class="topR"></div>
          <div class="topBL"></div>
          <div class="topBR"></div>
          <div id="mychart1"></div>
          <div class="lineContent">
            与上周相比过去半小时,营业额
            <span class="negativeNum" v-if="yyPercent<0">&#8659;{{0-yyPercent}}%</span>
            <span class="positiveNum" v-else>&#8657;{{yyPercent}}%</span>,客单量
            <span class="negativeNum" v-if="orderCountPercent<0">&#8659;{{0-orderCountPercent}}%</span>
            <span class="positiveNum" v-else>&#8657;{{orderCountPercent}}%</span>
            客单价
            <span class="negativeNum" v-if="orderPerPrice<0">&#8659;{{0-orderPerPrice}}</span>
            <span class="positiveNum" v-else>&#8657;{{orderPerPrice}}</span>。
          </div>
        </div>
        <div class="chart2 borderOut">
          <div class="topL"></div>
          <div class="topR"></div>
          <div class="topBL"></div>
          <div class="topBR"></div>
          <el-table :data="storeRankingData" :height="300" :cell-style="cellStyle">
            <el-table-column label="排名" prop="ItemOrderToday" width="70">
              <template slot-scope="scope">
                <span class="color: #ec1c24;font-weight: 600;" v-if="scope.row.ItemOrderToday<scope.row.IItemOrderLast">&#8659;{{scope.row.ItemOrderToday}}</span>
                <span style="color: rgb(29, 127, 30);font-weight: 600;" v-else>&#8657;{{scope.row.ItemOrderToday}}</span>
              </template>
            </el-table-column>
            <el-table-column label="门店" prop="Dept_Name"></el-table-column>
            <el-table-column label="营业额" prop="SumMoneyT" width="110"></el-table-column>
            <el-table-column label="上周营业额" prop="SumMoneyLast" width="117"></el-table-column>
            <el-table-column label="去年营业额" prop="SumMoneyLastYear" width="117">
              <template slot-scope="scope">
                <span>{{scope.row.SumMoneyLastYear || 0}}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="占比"
            >
            <template slot-scope="scope">
              <span class="color: #fe803b;font-weight: 600;" v-if="scope.row.OrderChange<0">&#8659;{{0-scope.row.OrderChange}}</span>
              <span style="color: #45d266;font-weight: 600;" v-else>&#8657;{{scope.row.OrderChange || 0}}</span>
            </template>
            </el-table-column>-->
          </el-table>
        </div>
        <div class="chart3 borderOut">
          <div class="topL"></div>
          <div class="topR"></div>
          <div class="topBL"></div>
          <div class="topBR"></div>
          <el-row>
            <el-col :span="12">
              <div class="boxtitle">
                <span>昨日流水</span>
              </div>
              <el-row>
                <el-col :span="14">昨日支出</el-col>
                <el-col :span="10">￥{{salesInfoData[1].ZC || 0}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="14">昨日利润</el-col>
                <el-col :span="10">￥{{salesInfoData[1].LR || 0}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="14">昨日报废率</el-col>
                <el-col :span="10">{{salesInfoData[1].BF || 0}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="14">昨日上班人数</el-col>
                <el-col :span="10">{{salesInfoData[1].Num || 0}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <div class="boxtitle">
                <span>今日流水</span>
              </div>
              <el-row>
                <el-col :span="14">今日支出</el-col>
                <el-col :span="10">￥{{salesInfoData[0].ZC || 0}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="14">今日利润</el-col>
                <el-col :span="10">￥{{salesInfoData[0].LR || 0}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="14">今日报废率</el-col>
                <el-col :span="10">{{salesInfoData[0].BF || 0}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="14">今日上班人数</el-col>
                <el-col :span="10">{{salesInfoData[0].Num || 0}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="15" style="width: 66%!important;">
        <div class="memberAndSalesInfo" style="margin-top:94px;">
          <div class="chartSalesInfo">
            <!-- <el-row style="position: absolute;">
              <el-col :span="24">
                <div class="titleArea">
                  <span class="title">{{companyName}} · 数据大脑</span>
                  <p>
                    <img src="@/assets/dataBrain/line.png" />
                  </p>
                </div>
              </el-col>
            </el-row>-->
            <el-row class="borderOut" style="    margin-top: 33px;">
              <el-col :span="12">
                <div class="topL"></div>
                <div class="topR"></div>
                <div class="topBL"></div>
                <div class="topBR"></div>
                <b class="circle1"></b>
                <b class="circle2"></b>
                <p class="topAmontTitle">营业额（元）</p>
                <dl>
                  <dt class="topYYAmount">
                    <!-- <div class="numberRun3">{{topYYAmount}}</div> -->
                    <div class="numberRun3">
                      <countTo :startVal="0" :endVal="topYYAmount" :duration="4000"></countTo>
                    </div>
                  </dt>
                </dl>
                <dl class="yyamoutTag">
                  <dt class="dttargetyyAmount">
                    <img src="@/assets/dataBrain/3_06.png" /> 目标
                    <br />
                    <div>{{targetyyAmount}}元,完成{{targetyyAmountPer}}%</div>
                  </dt>
                  <br />
                  <dt class="dttargetyyAmount">
                    <img src="@/assets/dataBrain/money.png" /> 上周同期营业额
                    <br />
                    <div>
                      {{lastWeekyyAmount}}元,
                      <span class="negativeNum" v-if="lastWeekyyAmountPer<0">&#8659;{{0-lastWeekyyAmountPer}}%</span>
                      <span class="positiveNum" v-else>&#8657;{{lastWeekyyAmountPer}}%</span>
                    </div>
                  </dt>
                  <br />
                  <dt class="dttargetyyAmount">
                    <img src="@/assets/dataBrain/3_10.png" /> 上周
                    <br />
                    <div>
                      {{yesyyAmount}}元,
                      <span class="negativeNum" v-if="yesyyAmountPer<0">&#8659;{{0-yesyyAmountPer}}%</span>
                      <span class="positiveNum" v-else>&#8657;{{yesyyAmountPer}}%</span>
                    </div>
                  </dt>
                </dl>
              </el-col>
              <el-col :span="6">
                <b class="top1"></b>
                <dl style="display: block; position: relative">
                  <dt class="toptitle2">客单数(笔)</dt>
                  <dt class="topOrderCount">
                    <span class="numberRun4">
                      <countTo :startVal="0" :endVal="topOrderCount" :duration="4000"></countTo>
                    </span>
                  </dt>
                </dl>
                <dl class="yyorderCount">
                  <dt class="dttargetyyAmount">
                    <img src="@/assets/dataBrain/06.png" /> 目标
                    <br />
                    <div>{{dttargetyyAmount}}元,完成{{dttargetyyAmountPer}}%</div>
                  </dt>
                  <dt class="dttargetyyAmount" style="padding-top:5px;">
                    <img src="@/assets/dataBrain/money.png" /> 上周同期客单数
                    <br />
                    <div>
                      {{targetorderCount}}笔,
                      <span class="negativeNum" v-if="targetorderCountPer<0">&#8659;{{0-targetorderCountPer}}%</span>
                      <span class="positiveNum" v-else>&#8657;{{targetorderCountPer}}%</span>
                    </div>
                  </dt>
                  <dt class="dtyesorderCount">
                    <img src="@/assets/dataBrain/03.png" /> 上周
                    <br />
                    <div>
                      {{dtyesorderCount}}笔,
                      <span class="negativeNum" v-if="dtyesorderCountPer<0">&#8659;{{0-dtyesorderCountPer}}%</span>
                      <span class="positiveNum" v-else>&#8657;{{dtyesorderCountPer}}%</span>
                    </div>
                  </dt>
                </dl>
              </el-col>
              <el-col :span="6">
                <b class="top2"></b>
                <dl style="display: block; position: relative">
                  <dt class="toptitle3">客单价(元)</dt>
                  <dt class="topOrderCount">
                    <span class="numberRun4">
                      <countTo :startVal="0" :endVal="sapnorderPrice" :duration="4000"></countTo>
                    </span>
                  </dt>
                </dl>
                <dl class="yyorderCount">
                  <dt class="dttargetyyAmount1">
                    <img src="@/assets/dataBrain/06.png" /> 行业均值
                    <br />
                    <div>{{targetorderPrice}}元,{{targetorderPricePer}}%</div>
                  </dt>
                  <dt class="dttargetyyAmount1" style="padding-top:5px;">
                    <img src="@/assets/dataBrain/money.png" /> 上周同期客单价
                    <br />
                    <div>
                      {{lastWeekOrderPrice}}元,
                      <span class="negativeNum" v-if="lastWeekOrderPricePer<0">&#8659;{{0-lastWeekOrderPricePer}}%</span>
                      <span class="positiveNum" v-else>&#8657;{{lastWeekOrderPricePer}}%</span>
                    </div>
                  </dt>
                  <dt class="dtyesorderCount1">
                    <img src="@/assets/dataBrain/03.png" /> 上周
                    <br />
                    <div>
                      {{yesorderPrice}}元,
                      <span class="negativeNum" v-if="yesorderPricePer<0">&#8659;{{0-yesorderPricePer}}%</span>
                      <span class="positiveNum" v-else>&#8657;{{yesorderPricePer}}%</span>
                    </div>
                  </dt>
                </dl>
              </el-col>
            </el-row>
          </div>
          <div>
            <!-- <el-row class="timeArea" style="position: absolute;">
              <el-col :span="24">
                <p>{{time}}</p>
                <p>技术支持：阿中软件</p>
              </el-col>
            </el-row>-->
            <el-row>
              <el-col :span="24" class="borderOut">
                <!-- <el-col :span="24" class="borderOut" style="margin-left:20px;margin-top:40px;"> -->
                <div class="topL"></div>
                <div class="topR"></div>
                <div class="topBL"></div>
                <div class="topBR"></div>
                <div class="chartMember">
                  <dl style="position: absolute;margin-top: 25px; padding-left: 280px">
                    今日：
                    <div style="display: inline-block; width: 30px; height: 15px; background-color: #3094c0"></div>&nbsp;昨日：
                    <div style="display: inline-block; width: 30px; height: 15px; background-color: #4ebe8a"></div>
                  </dl>
                  <div class="memberInfo">
                    <div>
                      <b class="membg"></b>
                    </div>
                    <dl>
                      <dt class="tNewMember">新增会员数</dt>
                      <dt class="newMember">
                        <el-row>
                          <el-col :span="4" style="text-align:right">{{tNewMember}}</el-col>
                          <el-col :span="16">
                            <el-progress :percentage="newMemberPer" :color="colors" :show-text="false"></el-progress>
                          </el-col>
                          <el-col :span="4">{{yesNewMember}}</el-col>
                        </el-row>
                      </dt>

                      <dt class="tReMemberPercent">回头客数量</dt>
                      <dt class="newMember">
                        <el-row>
                          <el-col :span="4" style="text-align:right">{{tReMemberPercent}}</el-col>
                          <el-col :span="16">
                            <el-progress :percentage="reMemberPer" :color="colors" :show-text="false"></el-progress>
                          </el-col>
                          <el-col :span="4">{{yesReMemberPercent}}</el-col>
                        </el-row>
                      </dt>
                      <dt class="tReMemberPercent">泛会员数</dt>
                      <dt class="newMember">
                        <el-row>
                          <el-col :span="4" style="text-align:right">{{tPanMember}}</el-col>
                          <el-col :span="16">
                            <el-progress :percentage="panMemberPer" :color="colors" :show-text="false"></el-progress>
                          </el-col>
                          <el-col :span="4">{{yesPanMember}}</el-col>
                        </el-row>
                      </dt>
                      <dt class="tReMemberPercent">会员消费（笔）</dt>
                      <dt class="newMember" style="margin-top: 4px;">
                        <el-row>
                          <el-col :span="4" style="text-align:right">{{tmemberConsume}}</el-col>
                          <el-col :span="16">
                            <el-progress :percentage="memberConsumePer" :color="colors" :show-text="false"></el-progress>
                          </el-col>
                          <el-col :span="4">{{yesMemberConsume}}</el-col>
                        </el-row>
                      </dt>
                    </dl>
                  </div>
                  <div class="memberImg">
                    <b class="circle3"></b>
                    <dl>
                      <dt class="summembernum">
                        <countTo :startVal="0" :endVal="summembernum" :duration="4000"></countTo>
                      </dt>
                      <dt class="membersum">会员总数(人)</dt>
                    </dl>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="salesOrder">
          <div class="chartSalesOrder borderOut">
            <div class="topL"></div>
            <div class="topR"></div>
            <div class="topBL"></div>
            <div class="topBR"></div>
            <div id="barXProductChart">
              <!-- 产品销售额排名 start -->
              <div class="data-box2 clearfix">
                <div class="box-body">
                  <div id="sale_pro" class="sale_sty">
                    <div id="sale_type" class="sale_type">
                      <ul>
                        <li v-for="(item,index) in productTypeList" :class="selectType==index?'productTypeSelect':'productType'" :key="index" @click="changeType(index)">{{item}}</li>
                      </ul>
                    </div>
                    <div class="sale_product">
                      <div class="prev"></div>
                      <div class="next"></div>
                      <div class="title">产品销售额排名</div>
                      <div class="thead">
                        <div class="order_th">
                          <span class="top"></span>
                        </div>
                        <div class="name_th"></div>
                        <div class="sales_amount_th">销量</div>
                        <div class="salse_th">销售额</div>
                        <div class="ml_th">毛利</div>
                        <div class="store">库存</div>
                        <div class="des">商品描述</div>
                      </div>
                      <table class="productDetail">
                        <tr v-for="(item,index) in productList[productTypeList[selectType]]" :key="index">
                          <td class="order_th" style="line-height:20px;">
                            <div :class="index==0?'one':index==1?'two':index==2?'three':'last'">{{index+1}}</div>
                          </td>
                          <td class="name_th">{{item.Product_Name}}</td>
                          <td class="sales_amount_th">{{item.Amount}}</td>
                          <td class="salse_th">{{item.TOTAL_MONEY}}</td>
                          <td class="ml_th">{{item.ML}}</td>
                          <td class="store">{{item.StockNum}}</td>
                          <td class="des">{{item.Description}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 产品销售额排名 end -->
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dataBrainApi from "@/api/api-dataBrain";
import countTo from "vue-count-to";
import Vue from "vue";
import { Progress } from "element-ui";
import globConfig from "@/config/config";
import axios from "axios";
import bingbao from "@/assets/weather/bingbao.png";
import lei from "@/assets/weather/lei.png";
import qing from "@/assets/weather/qing.png";
import shachen from "@/assets/weather/shachen.png";
import wu from "@/assets/weather/wu.png";
import xue from "@/assets/weather/xue.png";
import yin from "@/assets/weather/yin.png";
import yu from "@/assets/weather/yu.png";
import yun from "@/assets/weather/yun.png";
import { MessageBox } from "element-ui";
import common from "@/libs/common";
Vue.use(Progress);
let loading;
export default {
  name: "dataBrain",
  components: { countTo },
  data() {
    return {
      lineData: null,
      lineNum: 0,
      yyPercent: null,
      orderCountPercent: null,
      orderPerPrice: null,
      storeRankingData: [],
      storeRankingTimer: null,
      timer1: null,
      timer2: null,
      timer3: null,
      salesInfoData: [],
      topYYAmount: 0,
      targetyyAmount: 0,
      targetyyAmountPer: 0,
      lastWeekyyAmount: 0,
      lastWeekyyAmountPer: 0,
      yesyyAmount: 0,
      yesyyAmountPer: 0,
      topOrderCount: 0,
      dttargetyyAmount: 0,
      dttargetyyAmountPer: 0,
      targetorderCount: 0,
      targetorderCountPer: 0,
      dtyesorderCount: 0,
      dtyesorderCountPer: 0,
      sapnorderPrice: 0,
      targetorderPrice: 0,
      targetorderPricePer: 0,
      lastWeekOrderPrice: 0,
      lastWeekOrderPricePer: 0,
      yesorderPrice: 0,
      yesorderPricePer: 0,
      summembernum: 0,
      colors: "#3094c0",
      newMemberPer: 0,
      tNewMember: 0,
      yesNewMember: 0,
      tReMemberPercent: 0,
      reMemberPer: 0,
      yesReMemberPercent: 0,
      tPanMember: 0,
      panMemberPer: 0,
      yesPanMember: 0,
      tmemberConsume: 0,
      memberConsumePer: 0,
      yesMemberConsume: 0,
      productTypeList: [],
      selectType: 0,
      productList: [],
      totalType: 0,
      city: null,
      wea_img: null,
      tem1: null,
      tem2: null,
      pic: {
        bingbao: bingbao,
        lei: lei,
        qing: qing,
        shachen: shachen,
        wu: wu,
        xue: xue,
        yin: yin,
        yu: yu,
        yun: yun,
      },
      time: null,
      companyName: null,
    };
  },
  methods: {
    init() {
      this.getLineData();
      this.getStoreRanking();
      this.getSalesInfo();
      this.getMainSalesSum();
      this.getTopMember();
      this.getProductSalesOrder();
      this.getWeather();
      this.companyName = localStorage.getItem(globConfig.setTenantname);
      loading.close();
    },
    getLineData() {
      dataBrainApi.getTYLine().then(
        (result) => {
          let xaData = [];
          let yyyData = [];
          let yytData = [];
          let kdlyData = [];
          let kdltData = [];
          let kdjyData = [];
          let kdjtData = [];
          // for (let i in result) {
          //   xaData.push(result[i].时间段);
          //   yyyData.push(result[i].上周营业额 || 0);
          //   yytData.push(result[i].今天营业额 || 0);
          //   kdlyData.push(result[i].上周客单数 || 0);
          //   kdltData.push(result[i].今天客单数 || 0);
          //   kdjyData.push(result[i].上周客单价 || 0);
          //   kdjtData.push(result[i].今天客单价 || 0);
          // }
          let data = result.filter((item, index) => {
            xaData.push(item.时间段);
            yyyData.push(item.上周营业额 || 0);
            yytData.push(item.今天营业额 || 0);
            kdlyData.push(item.上周客单数 || 0);
            kdltData.push(item.今天客单数 || 0);
            kdjyData.push(item.上周客单价 || 0);
            kdjtData.push(item.今天客单价 || 0);
            if (item.今天营业额) {
              return item;
            }
          });
          this.yyPercent = parseFloat(data[data.length - 1].营业额百分比 || 0);
          this.orderCountPercent = parseFloat(
            data[data.length - 1].客单量百分比 || 0
          );
          this.orderPerPrice = parseFloat(data[data.length - 1].客单价 || 0);
          this.lineData = {
            //曲线图数据源
            xa: xaData,
            yy: {
              text: "实时营业额",
              yData: yyyData,
              tData: yytData,
            },
            kdl: {
              text: "客单量",
              yData: kdlyData,
              tData: kdltData,
            },
            kdj: {
              text: "客单价",
              yData: kdjyData,
              tData: kdjtData,
            },
          };
          this.lineNum = 1;
          this.getChart1(this.lineData.yy);
        },
        (err) => {}
      );
    },
    getChart1(opt) {
      //折线图
      let that = this;
      var mychart1 = that.$echarts.init(document.getElementById("mychart1"));
      /**折线*/
      let lineoption = {
        textStyle: {
          color: "#fff",
        },
        title: {
          text: opt.text,
          subtext: "",
          textStyle: {
            fontSize: 15,
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        color: ["#0672de", "#ccf2fc"],
        legend: {
          data: ["今日" + opt.text, "上周" + opt.text],
          textStyle: {
            color: "#fff",
          },
          icon: "stack",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: that.lineData.xa,
          axisLine: {
            lineStyle: {
              color: "#FFF",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#FFF",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            name: "今日" + opt.text,
            smooth: true,
            type: "line",
            data: opt.tData,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#0672de",
                },
              },
            },
          },
          {
            name: "上周" + opt.text,
            smooth: true,
            type: "line",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#ccf2fc",
                },
              },
            },
            data: opt.yData,
          },
        ],
      };
      mychart1.setOption(lineoption);
    },
    changeLinechart() {
      if (this.lineNum == 0) {
        this.lineNum = 1;
        this.getChart1(this.lineData.yy);
      } else if (this.lineNum == 1) {
        this.lineNum = 2;
        this.getChart1(this.lineData.kdl);
      } else if (this.lineNum == 2) {
        this.lineNum = 0;
        this.getChart1(this.lineData.kdj);
      }
    },
    getStoreRanking() {
      let that = this;
      dataBrainApi.getSalesDept().then((result) => {
        if (result.length > 10) {
          let page = 1;
          let total = Math.ceil(result.length / 10);
          that.storeRankingData = [];
          for (let i = 0; i < 10; i++) {
            that.storeRankingData.push(result[i]);
          }
          this.storeRankingTimer = setInterval(function () {
            if (page > total - 1) {
              clearInterval(that.storeRankingTimer);
              that.getStoreRanking();
            } else {
              let storeRankingData = [];
              for (let j = page * 10; j < (page + 1) * 10; j++) {
                if (result[j]) {
                  storeRankingData.push(result[j]);
                }
              }
              that.storeRankingData = storeRankingData;
              page++;
            }
          }, 10000);
        } else {
          this.storeRankingData = result;
          setTimeout(() => {
            // 重新请求
            that.getStoreRanking();
          }, 10000);
        }
      });
    },
    getSalesInfo() {
      dataBrainApi.getSalesInfo().then((result) => {
        this.salesInfoData = result;
      });
    },
    getMainSalesSum() {
      dataBrainApi.getMainSalesSum().then((r) => {
        let result = r[0];
        this.topYYAmount = result.今天营业额 || 0;
        this.targetyyAmount = result.目标营业额 || 0;
        this.targetyyAmountPer = result.目标营业额完成百分比 || 0;
        this.lastWeekyyAmount = result.上周同期营业额 || 0;
        this.lastWeekyyAmountPer = result.营业额上周同期对比百分比 || 0;
        this.yesyyAmount = result.上周营业额 || 0;
        this.yesyyAmountPer = result.营业额上周对比百分比 || 0;

        this.topOrderCount = result.今天客单数 || 0;
        this.dttargetyyAmount = result.目标客单数 || 0;
        this.dttargetyyAmountPer = result.目标客单数完成百分比 || 0;
        this.targetorderCount = result.上周同期客单数 || 0;
        this.targetorderCountPer = result.客单数上周同期对比百分比 || 0;
        this.dtyesorderCount = result.上周客单数 || 0;
        this.dtyesorderCountPer = result.客单数上周对比百分比 || 0;

        this.sapnorderPrice = result.今天客单价 || 0;
        this.targetorderPrice = result.行业客单价均值 || 0;
        this.targetorderPricePer = result.行业客单价均值对比百分比 || 0;
        this.lastWeekOrderPrice = result.上周同期客单价 || 0;
        this.lastWeekOrderPricePer = result.客单价上周同期对比百分比 || 0;
        this.yesorderPrice = result.上周客单价 || 0;
        this.yesorderPricePer = result.客单价上周对比百分比 || 0;
      });
    },
    getTopMember() {
      dataBrainApi.getTopMember().then((r) => {
        let result = r[0];
        this.tNewMember = result.T_Member || 0;
        this.yesNewMember = result.Y_Member || 0;
        if (this.tNewMember != 0 || this.yesNewMember != 0) {
          this.newMemberPer =
            (this.tNewMember / (this.tNewMember + this.yesNewMember)) * 100;
        } else {
          this.newMemberPer = 0;
        }

        this.tReMemberPercent = result.T_MemberH || 0;
        this.yesReMemberPercent = result.Y_MemberH || 0;
        if (this.tReMemberPercent != 0 || this.yesReMemberPercent != 0) {
          this.reMemberPer =
            (this.tReMemberPercent /
              (this.tReMemberPercent + this.yesReMemberPercent)) *
            100;
        } else {
          this.reMemberPer = 0;
        }

        this.tPanMember = result.T_MemberF || 0;
        this.yesPanMember = result.Y_MemberF || 0;
        if (this.tPanMember != 0 || this.yesPanMember != 0) {
          this.panMemberPer =
            (this.tPanMember / (this.tPanMember + this.yesPanMember)) * 100;
        } else {
          this.panMemberPer = 0;
        }

        this.tmemberConsume = result.T_MemberCount || 0;
        this.yesMemberConsume = result.Y_MemberCount || 0;
        if (this.tmemberConsume != 0 || this.yesMemberConsume != 0) {
          this.memberConsumePer =
            (this.tmemberConsume /
              (this.tmemberConsume + this.yesMemberConsume)) *
            100;
        } else {
          this.memberConsumePer = 0;
        }
        this.summembernum = result.TotalMember;
      });
    },
    getProductSalesOrder() {
      dataBrainApi.getProductSalesOrder().then((r) => {
        let productType = [];
        let productList = {};
        for (let i in r) {
          if (productType.length < 17) {
            let producTypeName = r[i].Product_Type_Name;
            if (productType.indexOf(r[i].Product_Type_Name) === -1) {
              productType.push(producTypeName);
              productList[producTypeName] = [];
            }
            productList[producTypeName].push(r[i]);
          }
        }
        this.productTypeList = productType;
        this.productList = productList;
        this.totalType = productType.length;
        this.selectType = 0;
      });
    },
    changeType(index) {
      this.selectType = index;
    },
    changeselectType() {
      if (this.selectType >= this.totalType - 1) {
        this.getProductSalesOrder();
      } else {
        this.selectType++;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getWeather() {
      let that = this;
      common.getWeather().then(
        (res) => {
          that.city = res.city;
          that.wea_img = that.pic[res.wea_img];
          that.tem2 = res.tem2;
          that.tem1 = res.tem1;
        },
        (err) => {}
      );
    },
    getTimmer() {
      let d = new Date();
      let str = "";
      str += d.getFullYear() + "年"; //获取当前年份
      str += d.getMonth() + 1 + "月"; //获取当前月份（0——11）
      str += d.getDate() + "日";
      str += d.getHours() + "时";
      str += d.getMinutes() + "分";
      str += d.getSeconds() + "秒";
      this.time = str;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // console.log("cellStyle");
      if (columnIndex === 0) {
        // 指定列号
        return "color:#4e9bed";
      } else {
        return "";
      }
    },
  },
  computed: {},
  mounted() {
    let that = this;
    // alert(window.screen.width + "*" + window.screen.height);
    if (window.screen.width != 1920 || window.screen.height != 1080) {
      // alert("建议使用1920*1080像素全屏打开当前页面！ ")
      const h = that.$createElement;
      MessageBox({
        message: h("div", null, [
          h("i", {
            class: "el-icon-warning message-login-title",
          }),
          h("span", { class: "message-login-txt" }, " 提示"),
          h(
            "p",
            { class: "message-login-content" },
            "建议使用1920*1080像素全屏打开当前页面！ "
          ),
        ]),
        showCancelButton: false,
        confirmButtonText: "确定",
        beforeClose: (action, instance, done) => {
          done();
        },
      });
    }
    loading = that.$loading({
      lock: true,
      text: "拼命加载中",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.6)",
    });
    that.init();
    that.timer1 = setInterval(function () {
      that.getLineData();
      that.getMainSalesSum();
    }, 30000);
    that.timer2 = setInterval(function () {
      that.changeLinechart();
      that.getSalesInfo();
      that.getMainSalesSum();
      that.getTopMember();
      that.changeselectType();
    }, 10000);
    that.timer3 = setInterval(function () {
      that.getTimmer();
    }, 1000);
  },
  destroyed() {
    let that = this;
    loading.close();
    clearInterval(that.storeRankingTimer);
    clearInterval(that.timer1);
    clearInterval(that.timer2);
    clearInterval(that.timer3);
    console.group("destroyed 销毁完成状态===============》");
  },
};
</script>
<style lang="less">
/*产品销售额排名 start*/
.sale_sty {
  width: 100%;
  display: flex;
  height: 600px;
  font: 12px Arial;
}
.sale_product {
  width: 100%;
  overflow: hidden;
  position: relative;
  margin-top: 10px;
}
.sale_product .title {
  color: #fff;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  background: url("../../assets/dataBrain/title_bg.png") no-repeat left center;
  font-family: "Microsoft YaHei", "Source Sans Pro", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-weight: 500;
  padding-left: 6px;
  letter-spacing: 1px;
  text-align: left;
}
.sale_product li {
  width: 100%;
  height: 600px;
  overflow: hidden;
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 0;
  color: #000;
}
.sale_product .thead {
  display: flex;
  font-weight: 600;
  // color: rgb(238, 236, 236);
  color: #fff;
  font-size: 16px;
  margin-top: 6px;
  > div {
    padding-right: 2px !important;
  }
}
.sale_product #product_detail {
  list-style-type: none;
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-inline-start: 0px !important;
}
.sale_product .order_th {
  width: 40px;
}
.sale_product .name_th {
  width: 250px;
  display: block;
  text-align: left;
  display: inline-block;
  white-space: nowrap;
  // width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sale_product .salse_th {
  width: 100px;
  // display: block;
}
.sale_product .sales_amount_th {
  width: 100px;
  // display: block;
}
.sale_product .ml_th {
  width: 100px;
  // display: block;
}
.sale_product .des {
  flex: 1;
  width: 310px;
  // display: block;
}
.sale_product .store {
  width: 100px;
  // display: block;
}
.sale_product li table {
  width: 100%;
  color: #fff;
  font-size: 16px;
}
.sale_product li table tr {
  height: 36px;
  line-height: 36px;
  display: flex;
}
.sale_product li table td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  // padding-left: 4px;
}
.sale_product li table td .one {
  background: #0e9ae5;
  padding: 1px 5px;
  border-radius: 10px;
  color: #fff;
}
.sale_product li table td .two {
  background: #947ff7;
  padding: 1px 5px;
  border-radius: 10px;
  color: #fff;
}
.sale_product li table td .three {
  background: #fb6780;
  padding: 1px 5px;
  border-radius: 10px;
  color: #fff;
}
.sale_product li table td .last {
  background: #9ba1b2;
  padding: 1px 5px;
  border-radius: 10px;
  color: #fff;
}
.opacity (@opacity) {
  @opacityPercentage: @opacity * 100;
  opacity: @opacity;
  -ms-filter: ~"progid:DXImageTransform.Microsoft.Alpha(opacity=(@{opacityPercentage}))";
  filter: ~"alpha(opacity = (@{opacityPercentage}))";
}
.sale_product .prev {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 130px;
  left: 10px;
  z-index: 3001;
  .opacity(0);
  cursor: pointer;
}

.sale_product .next {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 130px;
  right: 10px;
  z-index: 3001;
  .opacity(0);
  cursor: pointer;
}
.sale_type {
  width: 180px;
  position: relative;
  overflow: hidden;
  margin: 15px 40px 8px auto;
  font-family: "Microsoft YaHei", "Source Sans Pro", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #fff;
}
.sale_type ul {
  height: 94px;
  position: absolute;
  top: 0;
  left: 0;
  list-style: none;
  width: 100%;
  margin: 0 !important;
  margin-block-end: 0px;
  margin-block-start: 0px !important;
  list-style-type: none;
  padding-inline-start: 0px !important;
}
.sale_type li {
  width: 140px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  padding-right: 10px;
  cursor: pointer;
  color: #fff;
  list-style-type: none;
}
.sale_type img {
  width: 120px;
  height: 94px;
}
/*产品销售额排名 end*/
</style>



// WEBPACK FOOTER //
// src/view/main/dataBrain.vue